// extracted by mini-css-extract-plugin
export default {"picker":"PopoverPicker_picker__cQ7wf","inputWrapper":"PopoverPicker_inputWrapper__8Y2Ax","swatch":"PopoverPicker_swatch__MJP4M","popover":"PopoverPicker_popover__2+hIM"};